import { z } from 'zod';

export enum DeviceRole {
  CAMERA = 'ot-camera',
}

export const deviceRoleSchema = z.enum(DeviceRole);
